<script setup lang="ts">
import { ref, provide } from 'vue';
import { CdrContainer, CdrText } from '@rei/cedar';
import type { TMainState } from '../../models/types/ColumnsMainState';
import type { centerState } from '../../models/types/ColumnsCenterState';
import CategoriesComponent from './CategoriesComponent.vue';
import MobileArticleModal from './MobileArticleModal.vue';

const mainState = ref<TMainState>({
  helpCenter: '',
  mainCategory: '',
  secondaryCategory: '',
  articleId: '',
  adobeName: '',
});

const setState = (newState: Partial<TMainState>) => {
  mainState.value = { ...mainState.value, ...newState };
};

provide<centerState>('centerState', { setState, mainState });

</script>

<template>
  <section
    id="help-centers-mobile-columns"
    class="help-centers-u help-centers-u--mobile"
    data-ui="help-centers-mobile-columns"
  >
    <CdrContainer>
      <CdrText
        tag="h2"
        class="help-centers-u__title"
      >
        Explore all help topics
      </CdrText>
    </CdrContainer>
    <CategoriesComponent />
    <MobileArticleModal />
  </section>
</template>

<style lang="scss">
@import 'src/main/style/helpCenterColumnsUpdate.scss';
</style>
